import React from 'react';
import Icon from '../../../components/AppIcon';

const WalletStats = ({ credentials, className = '' }) => {
  const getStats = () => {
    const total = credentials?.length;
    const verified = credentials?.filter(c => c?.status === 'verified')?.length;
    const expired = credentials?.filter(c => c?.status === 'expired')?.length;
    const expiringSoon = credentials?.filter(c => {
      if (!c?.expirationDate) return false;
      const expirationDate = new Date(c.expirationDate);
      const thirtyDaysFromNow = new Date();
      thirtyDaysFromNow?.setDate(thirtyDaysFromNow?.getDate() + 30);
      return expirationDate <= thirtyDaysFromNow && expirationDate > new Date();
    })?.length;
    const blockchainAnchored = credentials?.filter(c => c?.blockchain)?.length;

    return {
      total,
      verified,
      expired,
      expiringSoon,
      blockchainAnchored,
      verificationRate: total > 0 ? Math.round((verified / total) * 100) : 0
    };
  };

  const stats = getStats();

  const statCards = [
    {
      label: 'Total Credentials',
      value: stats?.total,
      icon: 'FileText',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Verified',
      value: stats?.verified,
      icon: 'ShieldCheck',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Expiring Soon',
      value: stats?.expiringSoon,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Blockchain Anchored',
      value: stats?.blockchainAnchored,
      icon: 'Link',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    }
  ];

  return (
    <div className={`grid grid-cols-2 lg:grid-cols-4 gap-4 ${className}`}>
      {statCards?.map((stat, index) => (
        <div key={index} className="credential-card p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">{stat?.label}</p>
              <p className="text-2xl font-bold text-foreground mt-1">{stat?.value}</p>
            </div>
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WalletStats;